import { render, staticRenderFns } from "./IrsaliyeSeferExtraRouteAdd.vue?vue&type=template&id=320a1ec2&"
import script from "./IrsaliyeSeferExtraRouteAdd.vue?vue&type=script&lang=js&"
export * from "./IrsaliyeSeferExtraRouteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports